export default "__VITE_ASSET__2bd0312f__"